import { Services } from '@sigma-frontend-libs/commons'

import { components, icons, labelModes } from '@/utils'

import preloader from '@/components/preloader'
import overflow from '@/components/text/overflow'

function renderPreloader(h) {
  if (this.loading) {
    return h(preloader)
  }
}

function renderSearchField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.search,
        label: this.getTranslate('commons.labels.search'),
        afterIcon: icons.search,
        labelMode: labelModes.hidden,
        loading: this.loading,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.search = event
        }
      }
    }
  )
}
function renderSearch(h) {
  return h(
    'div',
    {
      class: 'tree-header__search'
    },
    [ renderSearchField.call(this, h) ]
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: 'tree-header'
    },
    [ renderSearch.call(this, h) ]
  )
}

function renderDescription(h, value, tooltip) {
  return h(
    'div',
    {
      class: 'tree__description',
      directives: [
        {
          name: 'g-tooltip',
          value: tooltip,
          options: {
            placement: 'top'
          }
        }
      ]
    },
    [ value ]
  )
}
function renderTitle(h, value) {
  return h(
    overflow,
    {
      class: 'tree__title',
      props: {
        value
      }
    }
  )
}
function renderSpacer(h) {
  return h(
    'div',
    {
      class: 'tree__spacer'
    }
  )
}
function renderContent(h, item) {
  const { mcc, mnc, country, operator, fullCountry } = item
  let operatorLabel = operator
  let operatorMNC = mnc
  if (fullCountry) {
    operatorLabel = undefined
    operatorMNC = undefined
  }

  return h(
    'div',
    {
      class: 'tree__content'
    },
    [
      renderDescription.call(this, h, mcc, this.getTranslate(`${Services.operatorGroups}.hints.tree.mcc`)),
      renderDescription.call(this, h, operatorMNC, this.getTranslate(`${Services.operatorGroups}.hints.tree.mnc`)),
      renderTitle.call(this, h, country),
      renderSpacer.call(this, h),
      renderDescription.call(this, h, operatorLabel),
      renderPreloader.call(this, h)
    ]
  )
}
function renderRow(h, item) {
  const { mcc, mnc } = item
  if (mcc || mnc) {
    return h(
      'div',
      {
        class: 'tree__row tree__row--readonly'
      },
      [ renderContent.call(this, h, item) ]
    )
  }
}
function renderHolder(h, item) {
  return h(
    'div',
    {
      class: 'tree__holder'
    },
    [ renderRow.call(this, h, item) ]
  )
}
function renderBody(h) {
  if (Array.isArray(this.values)) {
    if (this.values.length) {
      return h(
        'div',
        {
          class: 'tree__level tree__level--1'
        },
        [
          this.values.map(item => {
            return renderHolder.call(this, h, item)
          })
        ]
      )
    }
  }
}

function renderEmpty(h) {
  return h(
    'div',
    {
      class: 'tree__empty'
    },
    [ h(components.empty) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'tree'
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h) ?? renderEmpty.call(this, h)
    ]
  )
}
